export default [
  {
    path: '/v2/monthly-semester-mappings',
    name: 'monthly-semester-mappings',
    meta: { requiresAuth: true },
    component: () => import('./views/index.vue')
  }
]
